import Flickity from "flickity";

export default function Stepsblock() {
  Alpine.data("stepsblock", () => ({
    _flkty: null,
    _mql: null,

    init() {
      const track = this.$el.querySelector("[data-track]");
      if (!track) return;

      this._mql = window.matchMedia("(min-width: 768px)");

      const setup = () => {
        if (!this._mql.matches && !this._flkty) {
          this._flkty = new Flickity(track, {
            cellAlign: "left",
            contain: true,
            wrapAround: false,
            pageDots: false,
            prevNextButtons: false,
            draggable: true,
          });
          this._flkty.on("dragStart", () =>
            this._flkty.slider.childNodes.forEach(
              (slide) => (slide.style.pointerEvents = "none"),
            ),
          );
          this._flkty.on("dragEnd", () =>
            this._flkty.slider.childNodes.forEach(
              (slide) => (slide.style.pointerEvents = "all"),
            ),
          );
        } else if (this._mql.matches && this._flkty) {
          this._flkty.destroy();
          this._flkty = null;
        }
      };

      requestAnimationFrame(() => {
        setup();
      });
      this._mql.addEventListener("change", setup);
    },

    destroy() {
      if (this._flkty) {
        this._flkty.destroy();
        this._flkty = null;
      }
    },
  }));
}
